<template>
  <MarketCard :class="[classes.marketCard, 'parlay-card']">
    <MPUParlayCardHeader
      :eventId="eventId"
      :displaySport="sports.length === 1"
    />

    <div :class="classes.eventsWrapper">
      <MPUParlayEventRow
        v-for="parlayMarketOption in parlayMarketOptions"
        :key="parlayMarketOption.marketId"
        :eventId="parlayMarketOption.eventId"
        :marketId="parlayMarketOption.marketId"
        :orderedOptionIds="parlayMarketOption.options"
      />
    </div>

    <MPUParlayCardFooter :previewPicks="previewPicks" />
  </MarketCard>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, ref } from "vue";
import MarketCard from "../../../styled/MarketCard.vue";
import { createUseStyles } from "@fresh8/ad-data-composition/src/theme";
import {
  composeParlayMarketOptions,
  injectBetData,
  BetDataContext
} from "@fresh8/ad-data-composition/src/betData";
import MPUParlayCardHeader from "./MPUParlayCardHeader.vue";
import MPUParlayCardFooter from "./MPUParlayCardFooter.vue";
import MPUParlayEventRow from "./MPUParlayEventRow.vue";
import { injectPreview } from "@fresh8/ad-data-composition/src/preview";
import { provideParlayStates } from "@fresh8/ad-data-composition/src/parlayStates";

const { useStyles } = createUseStyles({
  cardName: {
    flex: 1
  },
  marketCard: {
    justifyContent: "space-between"
  },
  eventsWrapper: {
    width: "100%",
    height: "100%",
    padding: "8px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
  }
});

export default defineComponent({
  name: "ParlayCard",
  components: {
    MarketCard,
    MPUParlayCardHeader,
    MPUParlayEventRow,
    MPUParlayCardFooter
  },
  props: {
    marketIds: { type: Array as PropType<string[]>, required: true },
    eventId: { type: String, required: true }
  },
  setup(props) {
    const { classesRef } = useStyles(ref(props));
    const betData = injectBetData() as BetDataContext;
    const previewContext = injectPreview();
    const marketIds = computed(() => props.marketIds || []);

    provideParlayStates(betData);

    const previewPicks = computed(
      () => previewContext?.preview?.value.previewParlayPicks
    );

    const marketIdsRef = computed(() => marketIds.value);
    const parlayMarketOptions = composeParlayMarketOptions(marketIdsRef);

    return {
      classes: classesRef,
      parlayMarketOptions: computed(
        () => parlayMarketOptions.value.markets as any
      ),
      sports: computed(() => parlayMarketOptions.value.sports),
      previewPicks
    };
  }
});
</script>
